import styled from 'styled-components';

import { fontStyles, palette } from 'theme';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 15px;
  row-gap: 60px;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
    row-gap: 30px;
  }
  @media (max-width: 991px) {
    grid-template-columns: 1fr;
    row-gap: 15px;
  }
`;

const headerStyle = `
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: solid ${palette.black};
  border-width: 2px 0;
  width: 100%;
  margin-bottom: 15px;
  min-height: 50px;
`;
export const Header = styled.div`
  ${headerStyle}
`;

export const HeaderLink = styled.a.attrs(() => ({ target: '_blank', rel: 'noopener noreferrer' }))`
  ${headerStyle}
  color: ${palette.black};
  text-decoration: none;
`;

export const Title = styled.p`
  ${fontStyles.textUpper}
  padding-top: 2px;
`;

export const SubTitle = styled.p`
  ${fontStyles.text}
`;

export const Image = styled.a.attrs(() => ({ target: '_blank', rel: 'noopener noreferrer' }))`
  width: 100%;
  display: block;
  margin-top: 15px;
  position: relative;
  padding-top: 62%;
  background-image: url(${({ $src }) => $src});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-bottom: 15px;
`;
